// Pure decision logic for the trailing-divider reconciler, split out from the controller so it can
// be tested without a DOM (see trailing_divider_helpers.test.mjs). The controller does the DOM
// reading; everything that decides an answer lives here.
//
// Mirrors the server side deliberately: Builder::TrailingDivider picks the last *visible* section's
// divider height and falls back to 0px, and the two must agree or the reconciler would fight the
// stylesheet on every render. See ENG-31839.

export const NO_DIVIDER = '0px'

// @param sections [Array<{hidden: boolean, height: string}>] in document order
// @return {string} the CSS length the following sibling should be pulled up by
export function lastVisibleDividerHeight(sections) {
  for (let i = sections.length - 1; i >= 0; i--) {
    const section = sections[i]
    if (!section || section.hidden) continue

    // A visible section with no divider still answers the question — it answers "nothing", which
    // is what clears a stale offset left by a section that used to be last.
    return normalizeHeight(section.height)
  }

  // No visible section at all is not "no opinion": it is precisely when the footer must not move.
  return NO_DIVIDER
}

// Custom properties come back as author-written tokens ('6vw', '0px') or empty when unset.
export function normalizeHeight(value) {
  const trimmed = (value || '').trim()
  return trimmed === '' ? NO_DIVIDER : trimmed
}

// Only write an inline override when it would actually change the outcome — an inline value
// outranks all three of the server's per-breakpoint rules, so writing one unnecessarily would
// freeze the current breakpoint's answer across every width.
export function shouldOverride(fromDom, fromStylesheet) {
  return normalizeHeight(fromDom) !== normalizeHeight(fromStylesheet)
}
